import { Region } from '@boltenergy-be/shared'

export type EanLookupResponseBody = {
  electricity: string | null
  gas: string | null
}

export type GetContractConsumptionsResponseBody = {
  consumptionsCsv: string
}

export type GetCustomerBalancePayUrlResponseBody = {
  balancePayUrl: string
}

export type Town = {
  postalCode: number
  townName: string
  townCode: number
  mainTownName: string
  geoCode: string
  languageCode: 'NL' | 'FR'
}

export type Towns = Town[]

export type TownResponse = {
  towns: Town[]
  region: Region
}

// ENUMS

export enum SearchOpportunityTypes {
  CANCELLED = 'CANCELLED',
  EFFECTIVE = 'EFFECTIVE',
  TERMINATED = 'TERMINATED',
  TO_BE_CONFIRMED = 'TO_BE_CONFIRMED'
}
